export default "__VITE_ASSET__DYy2O_p___"